package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PlaylistAddW500Rounded: ImageVector
    get() {
        if (_playlistAddW500Rounded != null) {
            return _playlistAddW500Rounded!!
        }
        _playlistAddW500Rounded = Builder(name = "PlaylistAddW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(160.0f, 648.85f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.18f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(203.59f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                reflectiveQuadToRelative(-13.18f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.32f, 13.18f)
                lineTo(160.0f, 648.85f)
                close()
                moveTo(160.0f, 481.43f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.33f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.32f)
                quadToRelative(13.18f, -13.18f, 32.33f, -13.18f)
                horizontalLineToRelative(360.0f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.18f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.32f)
                quadToRelative(0.0f, 19.16f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(160.0f, 481.43f)
                close()
                moveTo(160.0f, 314.02f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.32f)
                quadToRelative(13.18f, -13.18f, 32.33f, -13.18f)
                horizontalLineToRelative(360.0f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.18f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.32f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(160.0f, 314.02f)
                close()
                moveTo(655.09f, 791.85f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                verticalLineToRelative(-110.67f)
                lineTo(531.0f, 648.85f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.18f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(110.91f)
                verticalLineToRelative(-110.92f)
                quadToRelative(0.0f, -19.15f, 13.18f, -32.32f)
                quadToRelative(13.17f, -13.18f, 32.32f, -13.18f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.18f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.32f)
                verticalLineToRelative(110.92f)
                horizontalLineToRelative(110.68f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                reflectiveQuadToRelative(-13.18f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.32f, 13.18f)
                lineTo(732.91f, 648.85f)
                verticalLineToRelative(110.67f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.33f, 13.17f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                close()
            }
        }
        .build()
        return _playlistAddW500Rounded!!
    }

private var _playlistAddW500Rounded: ImageVector? = null
